<template>
    <div class="com">
        <div id="userInfoArea">
            <div id="userInfo">欢迎 <span id="ic_userName">{{user.userName}} </span><span>{{userRole()}}</span>登录本系统</div>
        </div>

        <div id="headArea">
            问卷大调查
        </div>

        <!-- 动态背景 -->
        <ul class="background">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>

        <div>
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path
                    d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                    opacity=".25" class="shape-fill"></path>
                <path
                    d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                    opacity=".5" class="shape-fill"></path>
                <path
                    d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                    class="shape-fill"></path>
            </svg>
        </div>

        <!-- 查询页面 start -->
        <div v-if="flag.mainFlag" id="listArea">
            <el-button @click="dialogVisible = true" type="primary" plain><i class="el-icon-edit"></i>&nbsp;参与评教</el-button>
            <el-button v-if="tjxxFlag && statisticsButtonVisible" @click="generalInfo" type="primary" plain><i class="el-icon-tickets"></i>&nbsp;统计信息</el-button>

            <el-col :span="24">
                <div id="emptyInfo" v-if="queInfo.length == 0" class="grid-content bg-purple-dark">
                    没有可查看的评教信息
                </div>
            </el-col>

            <div id="listContainer">
                <div class="listContent" v-for="(item,index) in queInfo" :key="index" @click="openQue(queInfo[index].id,queInfo[index].lx)">
                    <el-row>
                        <el-col :span="5">
                            <img class="examIcon" src="../../../image/wjdc/icon-wj.png">
                        </el-col>
                        <el-col :span="14">
                            <p class="buttionFont">{{queInfo[index].xnxqmc}}</p>
                            <p class="buttionFont">评教名称:&nbsp;{{queInfo[index].pjbmc}}</p>
                            <p class="buttionFont">
                                评教时间:&nbsp;{{queInfo[index].pjsj}}
                            </p>
                        </el-col>
                        <el-col :span="5">
                            <div class="examState">
                                <div v-if="queInfo[index].state == 2" class="stateBlock"
                                    style="background-color: rgba(51,198,11,0.7);">已完成</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 查询页面 end -->

        <el-dialog title="参与评教" :visible.sync="dialogVisible" ref="dialogVisible" width="30%" top="300px" @open="openDialog">
            <el-form ref="queryQueForm" :model="queryQueForm" label-width="120px" label-position="left">
                <el-form-item label="学年学期" prop="xnxqbm" :rules="[{required: true, message: '请选择学年学期'}]">
                    <el-select v-model="queryQueForm.xnxqbm" placeholder="请选择" style="width:100%;" clearable>
                        <el-option v-for="(item, index) in comboData.semester" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="评教类型" prop="lx" :rules="[{required: true, message: '请选择评教类型'}]">
                    <el-select v-model="queryQueForm.lx" :placeholder="typeTips" :disabled="typeDisable" style="width:100%;" clearable>
                        <el-option v-for="(item, index) in comboData.type" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="createEvaluate">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 教师教学质量听课评价表 start -->
        <div v-if="flag.tkEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div style="width: 1100px;margin-left: 50px;">
                <tkEvaluate ref="tkEvaluate" :userCode="user.userCode" :userName="user.userName"
                    :semesterCode="queryQueForm.xnxqbm" :type="queryQueForm.lx" :semesterCombo="comboData.semester">
                </tkEvaluate>
            </div>
            <!-- 教师教学质量听课评价表 end -->
        </div>

        <!-- 查看已完成 - 教师教学质量听课评价表 start -->
        <div v-if="flag.queryTkEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div style="width: 1100px;margin-left: 50px;">
                <queryTkEvaluate ref="queryTkEvaluate" :tkQueData="tkQueData"></queryTkEvaluate>
            </div>
        </div>
        <!-- 查看已完成 - 教师教学质量听课评价表 end -->

        <!-- 教师教学质量评价（学生） start -->
        <div v-if="flag.stuEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div style="width: 1100px;margin-left: 50px;">
                <stuEvaluate ref="stuEvaluate" :stuName="user.userName" :stuCode="user.userCode" :type="queryQueForm.lx"
                    :semesterCode="queryQueForm.xnxqbm"></stuEvaluate>
            </div>
        </div>
        <!-- 教师教学质量评价（学生） end -->

        <!-- 查看已完成 - 教师教学质量评价（学生） start -->
        <div v-if="flag.queryStuEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div style="width: 1100px;margin-left: 50px;">
                <queryStuEvaluate ref="queryStuEvaluate" :stuName="user.userName" :stuCode="user.userCode"
                    :tableData="stuQueData"></queryStuEvaluate>
            </div>
        </div>
        <!-- 查看已完成 - 教师教学质量评价（学生） end -->

        <!-- 教师教学质量评价（系主任） start -->
        <div v-if="flag.xzrEvaluateFlag" class="grid-content bg-purple-dark xzrTable">
            <div style="width: 1300px;margin-left: 50px;">
                <xzrEvaluate ref="xzrEvaluate" :xzrCode="user.userCode" :type="queryQueForm.lx"
                    :semesterCode="queryQueForm.xnxqbm"></xzrEvaluate>
            </div>
        </div>
        <!-- 教师教学质量评价（系主任） end -->

        <!-- 查看已完成 - 教师教学质量评价（系主任） start -->
        <div v-if="flag.queryXzrEvaluateFlag" class="grid-content bg-purple-dark xzrTable">
            <div style="width: 1300px;margin-left: 50px;">
                <queryXzrEvaluate ref="queryXzrEvaluate" :tableData="xzrQueData"></queryXzrEvaluate>
            </div>
        </div>
        <!-- 查看已完成 - 教师教学质量评价（系主任） end -->

        <!-- 总览 start -->
        <div v-if="flag.generalInfoFlag" class="grid-content bg-purple-dark xzrTable">
            <generalInfo ref="generalInfo"></generalInfo>
        </div>
        <!-- 总览 end -->

        <div id="backButton">
            <el-button type="primary" v-show="flag.mainFlag !==true" @click="back" plain>
                <i class="el-icon-s-home"></i>&nbsp;返回
            </el-button>
            <el-button @click="submit"  type="warning" plain
                v-show="flag.stuEvaluateFlag===true || flag.tkEvaluateFlag===true || flag.xzrEvaluateFlag===true || flag.tkGgEvaluateFlag===true|| flag.tkZyEvaluateFlag===true">
                <i class="el-icon-s-promotion"></i>&nbsp;提交
            </el-button>
        </div>

        <!-- 听课记录表（公共基础） start -->
        <div v-if="flag.tkGgEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div>
                <tkGgEvaluate ref="tkGgEvaluate" :user-code="user.userCode" :type="queryQueForm.lx"
                             :semesterCode="queryQueForm.xnxqbm" :semesterCombo="comboData.semester"/>
            </div>
        </div>
        <!-- 听课记录表（公共基础） end -->

        <!-- 查看已完成 - 听课记录表（公共基础） start -->
        <div v-if="flag.queryTkGgEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div>
                <queryTkGgEvaluate ref="queryTkGgEvaluate" :tk-gg-que-data="tkGgQueData"/>
            </div>
        </div>
        <!-- 查看已完成 - 听课记录表（公共基础） end -->

        <!-- 听课记录表（专业课程） start -->
        <div v-if="flag.tkZyEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div>
                <tkZyEvaluate ref="tkZyEvaluate" :user-code="user.userCode" :type="queryQueForm.lx"
                              :semesterCode="queryQueForm.xnxqbm" :semesterCombo="comboData.semester"/>
            </div>
        </div>
        <!-- 听课记录表（专业课程） end -->

        <!-- 查看已完成 - 听课记录表（专业课程） start -->
        <div v-if="flag.queryTkZyEvaluateFlag" class="grid-content bg-purple-dark tkTable">
            <div>
                <queryTkZyEvaluate ref="queryTkZyEvaluate" :tk-gg-que-data="tkZyQueData"/>
            </div>
        </div>
        <!-- 查看已完成 - 听课记录表（专业课程） end -->




    </div>
</template>

<script>
    import {confirmMsg, showNotify} from "utils/message";
    import {globalConfig} from "static/config"

    import tkEvaluate from "./questionnaireServer/tkEvaluate.vue"
    import queryTkEvaluate from "./questionnaireServer/queryTkEvaluate.vue"
    import stuEvaluate from "./questionnaireServer/stuEvaluate.vue"
    import queryStuEvaluate from "./questionnaireServer/queryStuEvaluate.vue"
    import xzrEvaluate from "./questionnaireServer/xzrEvaluate.vue"
    import queryXzrEvaluate from "./questionnaireServer/queryXzrEvaluate.vue"
    import generalInfo from "./questionnaireServer/generalInfo.vue"
    import tkGgEvaluate from "./questionnaireServer/tkGgEvaluate.vue"
    import queryTkGgEvaluate from "./questionnaireServer/queryTkGgEvaluate.vue"
    import tkZyEvaluate from "./questionnaireServer/tkZyEvaluate.vue"
    import queryTkZyEvaluate from "./questionnaireServer/queryTkZyEvaluate.vue"

    export default {
        components: {
            tkEvaluate,
            queryTkEvaluate,
            stuEvaluate,
            queryStuEvaluate,
            xzrEvaluate,
            queryXzrEvaluate,
            generalInfo,
            tkGgEvaluate,
            queryTkGgEvaluate,
            tkZyEvaluate,
            queryTkZyEvaluate,
        },
        data() {
            return {
                statisticsButtonVisible: false,
                typeTips: null,
                typeDisable: false,
                flag: {
                    mainFlag: true,
                    tkEvaluateFlag: false,
                    queryTkEvaluateFlag: false,
                    stuEvaluateFlag: false,
                    queryStuEvaluateFlag: false,
                    xzrEvaluateFlag: false,
                    queryXzrEvaluateFlag: false,
                    generalInfoFlag: false,
                    tkGgEvaluateFlag: false,
                    queryTkGgEvaluateFlag: false,
                    tkZyEvaluateFlag: false,
                    queryTkZyEvaluateFlag: false
                },
                /*查看已完成 - 教师教学质量听课评价表 start*/
                tkQueData: {
                    basicInfo: [],
                    pjxInfo: [],
                    hjdf: 0
                },
                /*查看已完成 - 教师教学质量听课评价表 end*/

                /*查看已完成 - 教师教学质量评价表(学生) start*/
                stuQueData: [],
                /*查看已完成 - 教师教学质量评价表(学生) end*/

                /*查看已完成 - 教师教学质量评价表(系主任) start*/
                xzrQueData: [],
                /*查看已完成 - 教师教学质量评价表(系主任) end*/

                /*查看已完成 - 听课记录表（公共基础） start*/
                tkGgQueData: [],
                /*查看已完成 - 听课记录表（公共基础） end*/

                /*查看已完成 - 听课记录表（专业课程） start*/
                tkZyQueData:[],
                /*查看已完成 - 听课记录表（专业课程） end*/

                /*查询页面 start*/
                dialogVisible: false,
                comboData: {
                    semester: [],
                    type: []
                },
                //登录人信息
                user: {
                    userCode: "",
                    userName: "",
                    userRoles: [],
                },
                //问卷信息列表
                queInfo: [],
                //查询问卷
                queryQueForm: {
                    xnxqbm: "",
                    lx: "",
                },
                /*查询页面 start*/
                tjxxFlag:false,
            }
        },
        mounted() {
            this.userInfo();
        },
        methods: {
            generalInfo() {
                this.flag.mainFlag = false;
                this.flag.generalInfoFlag = true;
            },
            submit() {
                if (this.flag.stuEvaluateFlag == true) {
                    this.$refs.stuEvaluate.submit();
                }
                if (this.flag.xzrEvaluateFlag == true) {
                    this.$refs.xzrEvaluate.submit();
                }
                if (this.flag.tkEvaluateFlag == true) {
                    this.$refs.tkEvaluate.submit();
                }
                if (this.flag.tkGgEvaluateFlag == true) {
                    this.$refs.tkGgEvaluate.submit();
                }
                if (this.flag.tkZyEvaluateFlag == true) {
                    this.$refs.tkZyEvaluate.submit();
                }
            },
            userRole() {
                if (this.user.userRoles.indexOf(globalConfig.auth.xs) > -1) {
                    return "同学";
                } else {
                    this.statisticsButtonVisible = true;
                    return "老师";
                }
            },
            back() {
                if (this.flag.stuEvaluateFlag == true || this.flag.xzrEvaluateFlag == true || this.flag.tkEvaluateFlag == true || this.flag.tkGgEvaluateFlag == true || this.flag.tkZyEvaluateFlag == true) {
                    confirmMsg('退出后数据不保存,是否确定退出?').then(() => {
                        this.flag.mainFlag = true;
                        this.flag.stuEvaluateFlag = false;
                        this.flag.xzrEvaluateFlag = false;
                        this.flag.tkEvaluateFlag = false;
                        this.flag.tkGgEvaluateFlag = false;
                        this.flag.tkZyEvaluateFlag = false;
                        this.finishedQue()
                    });
                } else {
                    this.flag.mainFlag = true;
                    this.flag.queryStuEvaluateFlag = false;
                    this.flag.queryTkEvaluateFlag = false;
                    this.flag.queryXzrEvaluateFlag = false;
                    this.flag.generalInfoFlag = false;
                    this.flag.queryTkGgEvaluateFlag = false;
                    this.flag.queryTkZyEvaluateFlag = false;
                    this.finishedQue()
                }
            },
            openDialog() {
                if (this.$refs['queryQueForm'] !== undefined) {
                    this.$refs['queryQueForm'].clearValidate();
                    this.$refs['queryQueForm'].resetFields();
                }
                this.queryQueForm.xnxqbm = null;
                this.queryQueForm.lx = null;
            },
            format(dat) {
                //获取年月日，时间
                var year = dat.getFullYear();
                var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
                var day = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();

                var newDate = year + "-" + mon + "-" + day;
                return newDate;
            },

            /*查看已完成 - 教师教学质量听课评价表 start*/
            openQue(id, type) {
                if (type === "01") {
                    //学生表
                    this.$api.evaluateManage.questionnaireServer.openStuQue({
                            data: id
                        })
                        .then((res) => {
                            this.stuQueData = res.data.data
                        }).catch((err) => {
                            console.log(err);
                        });
                    this.flag.queryStuEvaluateFlag = true;
                    this.flag.mainFlag = false;
                } else if (type === "02") {
                    //系主任表
                    this.$api.evaluateManage.questionnaireServer.openXzrQue({
                            data: id
                        })
                        .then((res) => {
                            this.xzrQueData = res.data.data
                        }).catch((err) => {
                            console.log(err);
                        });
                    this.flag.queryXzrEvaluateFlag = true;
                    this.flag.mainFlag = false;
                } else if (type === "03") {
                    //听课表
                    this.$api.evaluateManage.questionnaireServer.openTkQue({
                            data: id
                        })
                        .then((res) => {
                            this.tkQueData.hjdf = 0;

                            this.tkQueData.basicInfo = res.data.data.basicInfo
                            this.tkQueData.pjxInfo = res.data.data.pjxInfo
                            this.tkQueData.basicInfo.jxnrgc = this.tkQueData.basicInfo.jxnrgc.replace(/\n/g,'<br>');
                            this.tkQueData.basicInfo.zhpjjy = this.tkQueData.basicInfo.zhpjjy.replace(/\n/g,'<br>');
                            for (var i = 0; i < this.tkQueData.pjxInfo.length; i++) {
                                this.tkQueData.hjdf += parseInt(this.tkQueData.pjxInfo[i].pf);
                            }
                            this.flag.queryTkEvaluateFlag = true;
                            this.flag.mainFlag = false;
                        }).catch((err) => {
                            console.log(err);
                        });
                }else if(type === '04' || type === '05'){
                    //公共基础 || 专业课程
                    this.$api.evaluateManage.questionnaireServer.openTkGgZyQue({
                        data: id
                    })
                        .then((res) => {
                            if(type === '04'){
                                this.tkGgQueData = res.data.data
                                this.flag.queryTkGgEvaluateFlag = true;
                            }

                            if(type === '05'){
                                this.tkZyQueData = res.data.data
                                this.flag.queryTkZyEvaluateFlag = true;
                            }
                            this.flag.mainFlag = false;
                        }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            /*查看已完成 - 教师教学质量听课评价表 end*/

            /*查询页面 start*/
            //创建评教
            createEvaluate() {
                this.$refs["queryQueForm"].validate((valid) => {
                    if (valid) {
                        //听课表可重复做
                        if (this.queryQueForm.lx === "01" || this.queryQueForm.lx === "02") {
                            let formData = new FormData();
                            formData.append('type', this.queryQueForm.lx);
                            formData.append('semesterCode', this.queryQueForm.xnxqbm)
                            formData.append('userCode', this.user.userCode)
                            this.$api.evaluateManage.questionnaireServer.createEvaluate({
                                    data: formData
                                })
                                .then((res) => {
                                    if (res.data.data == "veto") {
                                        this.$alert("当前学期已完成该评教", "提示", {
                                            confirmButtonText: "确定",
                                        });
                                    } else {
                                        this.flag.mainFlag = false;

                                        if (this.queryQueForm.lx == "01") {
                                            this.flag.stuEvaluateFlag = true
                                        }

                                        if (this.queryQueForm.lx == "02") {
                                            this.flag.xzrEvaluateFlag = true
                                        }
                                        this.dialogVisible = false;
                                    }
                                }).catch((err) => {
                                    console.log(err);
                                });
                        } else {

                            this.flag.mainFlag = false;

                            if(this.queryQueForm.lx === "03"){
                                this.flag.tkEvaluateFlag = true
                            }else if(this.queryQueForm.lx === "04"){
                                this.flag.tkGgEvaluateFlag = true
                            }else {
                                this.flag.tkZyEvaluateFlag = true
                            }

                            this.dialogVisible = false;
                        }
                    } else {
                        return false;
                    }
                });
            },
            //角色信息
            userInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        this.user.userName = userInfo.name;
                        this.user.userCode = userInfo.phone;
                        for (let roleCode in userInfo.roles) {
                            this.user.userRoles.push(roleCode);
                            if(roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.dd){
                                this.tjxxFlag = true
                            }
                        }
                    }

                    this.initCombo();
                    this.finishedQue();
                }).catch((err) => {
                    console.log(err);
                });
            },
            //已完成问卷
            finishedQue() {
                this.$api.evaluateManage.questionnaireServer.finishedQue({
                    data: this.user.userCode
                }).then((res) => {
                    this.queInfo = res.data.data;
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });
            },
            //下拉框数据
            initCombo() {
                this.$api.common.comboOption.semester({}).then((res) => {
                    this.comboData.semester = res.data.data.comboData
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });

                this.$api.evaluateManage.questionnaireServer.type({
                    data: this.user.userRoles.toString()
                }).then((res) => {
                    this.comboData.type = res.data.data.comboData;
                    if(this.comboData.type.length === 0){
                        this.typeTips = '暂无可以参与的评教类型';
                        this.typeDisable = true;
                    }else{
                        this.typeTips = '请选择';
                        this.typeDisable = false;
                    }
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });
            }
            /*查询页面 end*/
        },
    }
</script>


<style>
    #backButton {
        position: absolute;
        top: 92%;
        left: 88%;
        z-index: 200;
    }

    .tkTable {
        width: 1200px;
        height: calc(100% - 200px);
        background-color: #ffffff;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin: 20px auto 20px auto;
        overflow-y: auto;
    }

    .xzrTable {
        width: 1400px;
        height: calc(100% - 200px);
        background-color: #ffffff;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin: 20px auto 20px auto;
        overflow-y: auto;
    }


    .buttonClass {
        width: 1000px;
        height: 120px;
        padding: 0;
    }

    .buttionFont {
        font-size: 15px;
        text-align: left;
    }

    /* ------------------------------------------------------------ */
    .com {
        height: calc(100vh);
        margin: 0;
        padding: 0;
        background-color: #D0E6FE;
        overflow-x: hidden;
        overflow: hidden;
    }

    #userInfoArea {
        position: absolute;
        top: 5px;
        right: 0;
        z-index: 10;
    }

    #userInfo {
        height: 25px;
        line-height: 25px;
        float: right;
        color: #ffffff;
        margin-right: 20px;
    }

    #ic_userName {
        font-weight: bold;
        color: #F5AA37;
    }

    #headArea {
        width: 100%;
        height: 80px;
        background-color: #1EA0FE;
        font-size: 55px;
        letter-spacing: 12px;
        color: #FFFFFF;
        text-shadow: 3px 3px 5px #9DD4FD;
        text-align: center;
        padding-top: 20px;
    }

    /* ------------------------------动画背景------------------------------ */
    @keyframes animate {
        0% {
            transform: translateY(0) rotate(0deg);
            opacity: 0.7;
            border-radius: 0;
        }

        100% {
            transform: translateY(-1000px) rotate(720deg);
            opacity: 0;
            border-radius: 50%;
        }
    }

    .background {
        position: absolute;
        width: 100%;
        height: 150px;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0;
        background: rgba(31, 162, 255, 0);
        overflow: hidden;
        z-index: 0;
    }

    .background li {
        position: absolute;
        display: block;
        list-style: none;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.2);
        animation: animate 10s linear infinite;
        -webkit-animation: animate 18s linear infinite;
    }

    .background li:nth-child(0) {
        left: 80%;
        width: 50px;
        height: 50px;
        bottom: -50px;
        animation-delay: 2s;
    }

    .background li:nth-child(1) {
        left: 45%;
        width: 105px;
        height: 105px;
        bottom: -105px;
        animation-delay: 4s;
    }

    .background li:nth-child(2) {
        left: 60%;
        width: 120px;
        height: 120px;
        bottom: -120px;
        animation-delay: 5s;
    }

    .background li:nth-child(3) {
        left: 85%;
        width: 77px;
        height: 77px;
        bottom: -77px;
        animation-delay: 7s;
    }

    .background li:nth-child(4) {
        left: 20%;
        width: 102px;
        height: 102px;
        bottom: -102px;
        animation-delay: 8s;
    }

    .background li:nth-child(5) {
        left: 55%;
        width: 65px;
        height: 65px;
        bottom: -65px;
        animation-delay: 10s;
    }

    .background li:nth-child(6) {
        left: 89%;
        width: 70px;
        height: 70px;
        bottom: -70px;
        animation-delay: 11s;

    }

    svg {
        /* position: relative; */
        /* display: block; */
        width: calc(370% + 1.3px);
        height: 90px;
    }

    .shape-fill {
        fill: rgb(31 161 255);
    }

    #listArea {
        height: calc(100% - 180px);
        text-align: center;
        overflow: hidden;
    }

    #listContainer {
        height: 100%;
        margin-top: 20px;
        padding-bottom: 50px;
        overflow-y: auto;
    }

    .listContent {
        width: 1000px;
        margin-top: 25px;
        background-color: #FFFFFF;
        border: 2px solid #FFFFFF;
        border-radius: 5px;
        margin: 0 auto 30px auto;
        cursor: pointer;
    }

    .listContent:hover {
        border: 2px solid #1EA0FE;
    }

    .examInfo {
        width: 100%;
        height: 130px;
        margin-bottom: 20px;
        border: 2px solid transparent;
        background-color: #ffffff;
        border-radius: 10px;
        cursor: pointer;
    }

    #emptyInfo {
        width: 1000px;
        height: 120px;
        line-height: 120px;
        font-size: 18px;
        font-weight: bold;
        color: #DCDFE6;
        background-color: #ffffff;
        border-radius: 10px;
        text-align: center;
        margin: 20px auto 20px auto;
    }

    .examInfo:hover {
        border-color: #1EA0FE;
    }

    .examIcon {
        width: 100px;
        height: 100px;
        background-size: 100%;
        margin: 10px 0 0 50px;
        float: left;
    }

    .examContent {
        height: 100%;
        float: left;
        display: flex;
        align-items: center;
    }

    .examState {
        width: 150px;
        height: 100%;
        float: right;
        margin: 45px 0 0 50px;

    }

    .stateBlock {
        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 3px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// questionnaireServer.vue?25a0b7e4